import { render, staticRenderFns } from "./MaungFB.vue?vue&type=template&id=441f19ff&scoped=true"
import script from "./MaungFB.vue?vue&type=script&lang=js"
export * from "./MaungFB.vue?vue&type=script&lang=js"
import style0 from "./MaungFB.vue?vue&type=style&index=0&id=441f19ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441f19ff",
  null
  
)

export default component.exports